"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _editJump = _interopRequireDefault(require("./editJump.vue"));
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var jumpApi = _interopRequireWildcard(require("@/api/jumpApi"));
var _companyappApi = require("@/api/companyappApi");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    EditJump: _editJump.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        keywords: null,
        cid: null,
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      brandOption: [],
      customerList: [],
      showTypeMap: {
        0: '不设权限',
        1: '展示',
        2: '不展示'
      },
      userType: null,
      currentCustomerId: null,
      customerName: ''
    };
  },
  created: function created() {
    this.userType = JSON.parse(_jsCookie.default.get('JavaInfo')).type;
    try {
      var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
      if (Number(this.userType) === 5 && JavaInfo.customerId) {
        this.currentCustomerId = JavaInfo.customerId;
        this.listPram.customerId = JavaInfo.customerId;
        this.fetchCustomerName(JavaInfo.customerId);
      }
    } catch (e) {
      // 静默忽略：cookie 解析失败时维持空值
    }
  },
  fetchCustomerName: function () {
    var _fetchCustomerName = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(customerId) {
      var list, item, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            _context.n = 1;
            return (0, _companyappApi.customersListApi)({
              types: 3
            });
          case 1:
            list = _context.v;
            item = (list || []).find(function (it) {
              return String(it.id) === String(customerId);
            });
            this.customerName = item ? item.name : String(customerId);
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            this.customerName = String(customerId);
          case 3:
            return _context.a(2);
        }
      }, _callee, this, [[0, 2]]);
    }));
    function fetchCustomerName(_x) {
      return _fetchCustomerName.apply(this, arguments);
    }
    return fetchCustomerName;
  }(),
  computed: {
    isMiniProgramCustomer: function isMiniProgramCustomer() {
      return Number(this.userType) === 5;
    }
  },
  mounted: function mounted() {
    this.handlerGetListData(this.listPram);
    if (!this.isMiniProgramCustomer) {
      this.searchBrand('');
      this.searchCustomer('');
    }
  },
  methods: {
    throttle: _throttle.default,
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      var params = _objectSpread({}, this.listPram);
      if (this.isMiniProgramCustomer) {
        delete params.authority;
        delete params.fuCartIds;
        // 小程序客户保留 customerId 用于按客户过滤
      } else {
        delete params.customerId;
      }
      this.handlerGetListData(params);
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.listLoading = true;
      var params = _objectSpread({}, pram);
      if (this.isMiniProgramCustomer) {
        delete params.authority;
        delete params.fuCartIds;
        // 小程序客户保留 customerId
      } else {
        delete params.customerId;
      }
      jumpApi.jumpListArticle(params).then(function (data) {
        _this.listData = data;
        _this.listLoading = false;
      }).catch(function (err) {
        _this.listLoading = false;
      });
    },
    handlerOpenEdit: function handlerOpenEdit(row) {
      this.$refs['EditJumpRef'].openInit(row);
    },
    handlerDelete: function handlerDelete(rowData) {
      var _this2 = this;
      this.$confirm('确定删除当前数据', '提示').then(function (result) {
        jumpApi.jumpDelArticle(rowData).then(function (data) {
          _this2.$message.success('删除数据成功');
          _this2.handlerGetListData(_this2.listPram);
        });
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    searchBrand: function searchBrand() {
      var _this3 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.brandOption = [];
      jumpApi.selectCard(keyword).then(function (res) {
        _this3.brandOption = res || [];
      });
    },
    handleAgreementSearch: function handleAgreementSearch(data) {
      var _this4 = this;
      this.throttle(function () {
        _this4.searchBrand(data);
      }, 300)();
    },
    remoteMethod: function remoteMethod() {
      this.searchBrand('');
    },
    onCustomerVisibleChange: function onCustomerVisibleChange(visible) {
      if (visible) {
        this.searchCustomer('');
      }
    },
    searchCustomer: function searchCustomer() {
      var _this5 = this;
      var keyword = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      (0, _companyappApi.customersListApi)({
        name: keyword,
        types: 3
      }).then(function (res) {
        _this5.customerList = res || [];
      }).catch(function () {
        _this5.customerList = [];
      });
    },
    transportShowType: function transportShowType(type) {
      var info = jumpApi.transportJumpType(type);
      return info === null || info === void 0 ? void 0 : info.title;
    }
  }
};